import script from "./ImportPortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportPortfolio.vue?vue&type=script&setup=true&lang=js"

import "./ImportPortfolio.vue?vue&type=style&index=0&id=a648281a&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a648281a"]])

export default __exports__